<template>
  <div id="breadcrumb">
    <ol class="breadcrumb">
      <li v-if="grandpa">
        <small>{{grandpa}}</small>
      </li>
      <li v-if="father">
        <small>{{father}}</small>
      </li>
      <li v-if="self">
        <small>{{self}}</small>
      </li>
      <li v-if="child">
        <small>{{child}}</small>
      </li>
    </ol>
  </div>
</template>

<script>
  export default {
    name: "index",
    props: {
      grandpa: {
        type: '',
        default: () => {
        }
      },
      father: {
        type: '',
        default: () => {
        }
      },
      self: {
        type: '',
        default: () => {
        }
      },
      child: {
        type: '',
        default: () => {
        }
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/breadcrumb/index.vue